import cn from 'classnames';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { FeatureFlag } from '@/shared/api/protocol-ts/model/dto_organization_pb';
import { useAppSelector, useMedia } from '@/shared/hooks';
import { Accordion, WidgetCard } from '@/shared/ui';

import { conditionModel } from '@/entities/condition';
import { organizationModel } from '@/entities/organization';

import { useFDA3DGPRestrictions } from '@/features/fdaRestrictions';

import styles from './NonDentalFindings.module.scss';
import { RarePathologies } from './RarePathologies/RarePathologies';

type NonDentalFindingsProps = {
  className?: string;
};

export const NonDentalFindings: FC<NonDentalFindingsProps> = (props) => {
  const { className } = props;

  const { isMobile } = useMedia();

  const hideNonDentalFindings = useAppSelector(
    organizationModel.selectors.selectFeatureFlag(
      FeatureFlag.FeatureFlag_Hide_NonDentalFindings,
    ),
  );

  const { shouldHideOtherFindings } = useFDA3DGPRestrictions();

  const maxFaxConditionsGrouped = useAppSelector(
    conditionModel.selectors.selectMaxFaxGroupedByCode,
  );

  if (
    hideNonDentalFindings ||
    shouldHideOtherFindings ||
    Object.keys(maxFaxConditionsGrouped).length === 0
  ) {
    return null;
  }

  return (
    <WidgetCard
      className={cn(styles.container, className)}
      data-component="non-dental-findings-card"
    >
      <Accordion.Root type="single" collapsible defaultValue="one">
        <Accordion.Item value="one">
          <Accordion.Header>
            <Accordion.Trigger withRightButton>
              <h4 className={cn(styles.title, isMobile ? 'h2m' : 'h4')}>
                <FormattedMessage
                  id="report.rarePathology.header"
                  defaultMessage="Other findings"
                />
              </h4>
            </Accordion.Trigger>
          </Accordion.Header>

          <Accordion.Content className={styles.content}>
            <RarePathologies conditionsGrouped={maxFaxConditionsGrouped} />
          </Accordion.Content>
        </Accordion.Item>
      </Accordion.Root>
    </WidgetCard>
  );
};
